import React from "react";

const Footer = () => (
  <footer className="custom-footer-bg p-3 text-center">
    <div className="logo" />
    <p>
      <a href="https://fairplay.ai">FairPlay AI, Inc.</a>
    </p>
  </footer>
);

export default Footer;
